import ChangePassword from '@/components/modals/ChangePassword';
import { useTransactionContext } from '@/context/TransactionContext';
import GlobalDivider from '@/utils/divider/GlobalDivider';

import { BarcodeOutlined, LockFilled } from '@ant-design/icons';
import { Button, List, Select, Switch } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * DrawerSettings component to display and manage user settings like language and password change.
 *
 * @param {Object} props - Component properties.
 * @param {function} props.onShowChangePassword - Function to show change password modal.
 * @returns {JSX.Element} The DrawerSettings component.
 */
const DrawerSettings = ({ onClose }) => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('en');
  const [isChangePasswordModalVisible, setIsChangePasswordModalVisible] =
    useState(false);
  const [barcodeSettingModalVisible, setBarcodeSettingModalVisible] =
    useState(false);
  const { barcodePrinterStatus, setBarcodePrinterStatus } =
    useTransactionContext();

  /**
   * Handles language change.
   *
   * @param {string} value - The selected language.
   */
  const handleLanguageChange = (value) => {
    setLanguage(value);
  };

  const handleNavigation = (url) => {
    navigate(url);
    onClose();
  };

  return (
    <div>
      <GlobalDivider name="Settings" orientation="center" />
      <List
        itemLayout="horizontal"
        dataSource={[
          {
            title: 'Change Language',
            description: (
              <Select
                defaultValue={language}
                onChange={handleLanguageChange}
                style={{ width: 120 }}
              >
                <Option value="en">English</Option>
                <Option value="es">Spanish</Option>
                <Option value="fr">French</Option>
                <Option value="de">German</Option>
              </Select>
            ),
          },
          {
            title: 'Change Password',
            description: (
              <Button
                type="link"
                onClick={() => setIsChangePasswordModalVisible(true)}
              >
                <LockFilled /> Change Password
              </Button>
            ),
          },
          {
            title: 'Barcode Settings',
            description: (
              <>
                <Switch
                  checked={barcodePrinterStatus}
                  onChange={() => {
                    localStorage.setItem(
                      'barcodePrinterStatus',
                      !barcodePrinterStatus,
                    );
                    setBarcodePrinterStatus(!barcodePrinterStatus);
                  }}
                  checkedChildren={
                    <>
                      <BarcodeOutlined /> Barcode Enabled
                    </>
                  }
                  unCheckedChildren={
                    <>
                      <BarcodeOutlined /> Barcode Disabled
                    </>
                  }
                />
              </>
            ),
          },
        ]}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta title={item.title} description={item.description} />
          </List.Item>
        )}
      />
      <ChangePassword
        visible={isChangePasswordModalVisible}
        onCancel={() => setIsChangePasswordModalVisible(false)}
      />
    </div>
  );
};

export default DrawerSettings;
